const singleProductPage = "producto/";
const productsPage = "productos/";
const checkoutPage = "checkout/";
const constants = {
	BOCADITOS: `${productsPage}bocaditos`,
	DULCESYPOSTRES: `${productsPage}dulces-y-postres`,
	SALADOS: `${productsPage}salados`,
	PANESYENVASADOS: `${productsPage}panes-y-envsados`,
}
const URLS = {
	// Home page
	HOME: 'home',

	// Terms and Conditions
	TERMSCONDITIONS: 'terminos-condiciones',

	// Personalized Orders
	PERSONALIZED: 'pedidos-personalizados',

	// Single Product Pages
	// Most sold -----------------------------------------------------
	ENROLLADODEHOTDOG: `${singleProductPage}enrollado-de-hot-dog`,
	ENROLLADODEACEINTUNA: `${singleProductPage}enrollado-de-aceituna`,
	OREJITAS: `${singleProductPage}orejitas`,
	BISCOTELA: `${singleProductPage}biscotela`,
	EMPANADITADEQUESO: `${singleProductPage}empanadita-de-queso`,
	NIDODEAMOR: `${singleProductPage}nido-de-amor`,
	EMPANADADULCECONGRAJEA: `${singleProductPage}empanada-dulce-con-grajea`,
	EMPANADADULCECONAJONJOLI: `${singleProductPage}empanada-dulce-con-grajea`,
	EMPANADADULCECONCHOCOLATE: `${singleProductPage}empanada-dulce-con-chocolate`,
	EMPANADITADEPOLLO: `${singleProductPage}empanada-de-pollo`,
	// -----------------------------------------------------------------

	// Sub Category
	BOCADITOSSALADOS: `${constants.BOCADITOS}/salados`,
	BOCADITOSDULCES: `${constants.BOCADITOS}/dulces`,

	// Sub Category
	TORTASYPOSTRES: `${constants.DULCESYPOSTRES}/tortas-y-postres`,
	VELASYTOPPERS: `${constants.DULCESYPOSTRES}/velas-y-toppers`,
	GALLETASYMACARRONES: `${constants.DULCESYPOSTRES}/galletas-y-macarrones`,
	KEKES: `${constants.DULCESYPOSTRES}/kekes`,

	// Sub Category
	EMPANADASYFOCACCIAS: `${constants.SALADOS}/empanadas-y-focaccias`,
	LASANAS_SCHNITZELYSALMON: `${constants.SALADOS}/lasanas-schnitzel-salmon`,
	PASTELESYQUICHES: `${constants.SALADOS}/pasteles-y-quiches`,

	// Sub Category
	ENVASADOS: `${constants.PANESYENVASADOS}/envasados`,
	PANES: `${constants.PANESYENVASADOS}/panes`,

	// Checkout Page
	CHECKOUT: `${checkoutPage}`,
}

export const PRODUCTS = {
	'Bocaditos': constants.BOCADITOS,
	'Dulces y Postres': constants.DULCESYPOSTRES,
	'Salados': constants.SALADOS,
	'Panes y Envasados': constants.PANESYENVASADOS,
	'Envasados': URLS.ENVASADOS,
	'Panes': URLS.PANES,
	'Lasañas, Schnitzel y Salmón': URLS.LASANAS_SCHNITZELYSALMON,
	'Pasteles y Quiches': URLS.PASTELESYQUICHES,
	'Empanadas y Focaccias': URLS.EMPANADASYFOCACCIAS,
	'Kekes': URLS.KEKES,
	'Galletas y Macarrones': URLS.GALLETASYMACARRONES,
	'Velas y Toppers': URLS.VELASYTOPPERS,
	'Tortas y Postres': URLS.TORTASYPOSTRES,
	'Bocaditos Salados': URLS.BOCADITOSSALADOS,
	'Bocaditos Dulces': URLS.BOCADITOSDULCES,
	'Enrollado de Hotdog': URLS.ENROLLADODEHOTDOG,
	'Enrollado de Aceituna': URLS.ENROLLADODEACEINTUNA,
	'Orejitas': URLS.OREJITAS,
	'Biscotela': URLS.BISCOTELA,
	'Empanada de Queso': URLS.EMPANADITADEQUESO,
	'Nido de Amor': URLS.NIDODEAMOR,
	'Empanada Dulce Con Grajea': URLS.EMPANADADULCECONGRAJEA,
	'Empanada Dulce Con Ajonjoli': URLS.EMPANADADULCECONAJONJOLI,
	'Empanada Dulce Con Chocolate': URLS.EMPANADADULCECONCHOCOLATE,
	'Empanada de Pollo': URLS.EMPANADITADEPOLLO,
}

export const MOSTSOLD = {
	'Enrollado de Hotdog': URLS.ENROLLADODEHOTDOG,
	'Enrollado de Aceituna': URLS.ENROLLADODEACEINTUNA,
	'Orejitas': URLS.OREJITAS,
	'Biscotela': URLS.BISCOTELA,
	'Empanada de Queso': URLS.EMPANADITADEQUESO,
	'Nido de Amor': URLS.NIDODEAMOR,
	'Empanada Dulce Con Grajea': URLS.EMPANADADULCECONGRAJEA,
	'Empanada Dulce Con Ajonjoli': URLS.EMPANADADULCECONAJONJOLI,
	'Empanada Dulce Con Chocolate': URLS.EMPANADADULCECONCHOCOLATE,
	'Empanada de Pollo': URLS.EMPANADITADEPOLLO,
}

export const SINGLE_PAGES = {
	'Enrollado de Hotdog': URLS.ENROLLADODEHOTDOG,
	'Enrollado de Aceituna': URLS.ENROLLADODEACEINTUNA,
	'Orejitas': URLS.OREJITAS,
	'Biscotela': URLS.BISCOTELA,
	'Empanada de Queso': URLS.EMPANADITADEQUESO,
	'Nido de Amor': URLS.NIDODEAMOR,
	'Empanada Dulce Con Grajea': URLS.EMPANADADULCECONGRAJEA,
	'Empanada Dulce Con Ajonjoli': URLS.EMPANADADULCECONAJONJOLI,
	'Empanada Dulce Con Chocolate': URLS.EMPANADADULCECONCHOCOLATE,
	'Empanada de Pollo': URLS.EMPANADITADEPOLLO,
}

export default URLS;
